// VarifyOTPModal


import { useState } from "react";
import { Button } from "react-bootstrap";
import { ExclamationCircle } from "react-bootstrap-icons";
import Modal from 'react-bootstrap/Modal';
import { MdRealEstateAgent } from "react-icons/md";
import OTPInput from "react-otp-input";
import { Link } from "react-router-dom";
// import "../Login/Login.scss";

interface PropData {
    close: any;
    onSubmit?: any;
    message?: any;
    isShow: any;
    resendOtp?: any;
}

const VarifyOTPModal = (props: PropData) => {
    const [otp, setOtp] = useState<string>("");
    const onCancel = () => {
        props.close();
    };

    return (
        <>
            {
                props.isShow &&
                <Modal show={props.isShow}   {...props}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered className="opt-modal">
                    <div className="delete-modal rounded-4">
                        <div className="w-100 login-card rounded-4">
                            <div className="px-lg-5 px-3 py-5 rounded-4">
                                <div className="mb-3 text-center">
                                    <MdRealEstateAgent size={80} color="#1abecb" />
                                </div>
                                <div className=" ">
                                    <div className=" ">
                                        <h1 className="text-light font-bold mb-4 h2 text-center">
                                            OTP Verification
                                        </h1>
                                        <p className="text-white text-center">Enter 4 digits code we sent to Mobile <br />
                                            {props.message ? props.message : ""}
                                        </p>

                                        <div className="d-flex justify-content-center">
                                            <OTPInput
                                                onChange={(value: string) => { setOtp(value); }}
                                                value={otp}
                                                inputStyle="otpInputStyle form-control mx-2"
                                                numInputs={4}
                                                shouldAutoFocus={true}
                                                renderSeparator={<span></span>}
                                                renderInput={(props, index) => (
                                                    <input
                                                        {...props}
                                                        style={{ width: "80px", color: "black" }}
                                                    />
                                                )}
                                            />
                                        </div>


                                        <div className="text-center d-flex justify-content-center gap-3">
                                            <Button
                                                variant="dark"
                                                className="bg-danger px-5 mt-3 mb-3"
                                                type="submit"
                                                id="cancel-otp-button"
                                                onClick={() => onCancel()}
                                            >
                                                Cancel
                                            </Button>

                                            <Button
                                                variant="dark"
                                                className="btn-brand-1 bg-success px-5 mt-3 mb-3"
                                                type="submit"
                                                id="verify-otp-button"
                                                onClick={() => props.onSubmit(otp)}
                                                disabled={otp && otp.length === 4 ? false : true}
                                            >
                                                Verify
                                            </Button>
                                        </div>
                                    </div>

                                    <div className="text-center my-3 text-white">
                                        Didn't received verification OTP?{" "}
                                        <Link to={"#"}
                                            onClick={props.resendOtp && props.resendOtp}
                                            id="resend-button"
                                            className="text-brand font-14">
                                            {" "}
                                            Resed OTP
                                        </Link>{" "}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            }
        </>
    );
};

export default VarifyOTPModal;
